export const UBICATION = {
  country: 'Colombia',
  departament: 'Valle del cauca',
  city: 'Cali',
  direction: 'Carrera 119 No 60-144',
  additional: ''
}

export const PHONE = {
  cell_phone: '3183804842',
  landline: '3044388145'
}

export const PAGE_DOMAIN = 'clublentes.com'

export const EMAIL = 'clublentes@gmail.com'

export const APP_NAME = 'ClubLentes'

export const NIT = '1112474925-9'

export const OWNER = 'Jorge Enrique Sandoval Vélez'

export const DAYS_WARRANTY = 30

export const SCHEDULE = 'Lunes a Sabados'

export const CLOSE_TIME = 6
